<template>
    <div class="bg-f9f9f9">
        <Mainlayout></Mainlayout>
        <br /> <br /> <br /> <br />
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
    
                <CCard>
                    <div class="">
                        <h3 class="custom-20px-600 text-left mt-2 ml-5">Personal Information</h3>
                        <CRow class="mt-2 ml-4">
                            <CCol sm="1">
                                <img style="max-width:50px" src="../assets/img/iconUs.png" />
                            </CCol>
                            <CCol sm="11">
                                <label class="custom-14px-500 color-687588">We only support .JPG, .JPEG, or .PNG file</label>
                                <br />
                                <span style="display: inline-flex;"> <CButton class="button-Explore text-white"><span class="ml-2 mr-2">Upload Your Photo</span></CButton>
                                <CButton class="bg-white text-white"><span class="ml-2 mr-2 text-danger">Delete Your Image</span></CButton>
                                </span>
                            </CCol>
    
                            <CCol sm="6">
                                <label class="text-black mt-5">Full Name</label>
                                <input type="text" class="custom-input-app bg-white" placeholder="eg. Waren Waren" />
                            </CCol>
                            <CCol sm="6">
                                <label class="text-black mt-5">Email</label>
                                <input type="text" class="custom-input-app bg-white" placeholder="eg. Waren Waren" />
                            </CCol>
                            <CCol sm="6">
                                <label class="text-black mt-2">Phone Number</label>
                                <input type="text" class="custom-input-app bg-white" placeholder="eg. Waren Waren" />
                            </CCol>
                            <CCol sm="6">
                                <label class="text-black mt-2">Sport Category</label>
                                <select class="custom-input-app bg-white">
                                                                    <option value="" disabled selected>Please Select</option>
                  <option value="Tennis">Tennis</option>
                  <option value="Football">Football</option>
                </select>
                <div class="text-right mt-3 mb-3 mr-3">
<span style="display:inline-flex; text-align:right">
                <CButton class="button-bg-white-border-blue bg-white mr-2"><span class="ml-2 mr-2">Edit Profile</span></CButton>
                <CButton class="button-Explore text-white"><span class="ml-2 mr-2">Save Profile</span></CButton>
            </span>
        </div>
                            </CCol>

                        </CRow>
                    </div>
    
                </CCard>
    
            </CCol>
        </CCol>
        
        <CCol sm="12">
            <CCol sm="10" style="width: 90%;background-size: cover; margin: auto;">
                <div class="text-center custom-card-grey mb-5 mt-5">
                    <h3 class="custom-48px-600 mt-5">Have a question or <br />feedback?</h3>
                    <p class="custom-16px-400 color-171717">Have a question or feedback? Fill out the form below, and our team will be in</p>
                    <br /><br />
                    <span class="custom-blur-radius-bottom-right p-10 mt-5 text-white p-20 mb-5">
                                                           Contact Us <img style="width:20px" src="../assets/img/Calling.png" />
                                                       
                                                        </span>
                    <br /><br /> <br /><br />
    
                </div>
    
            </CCol>
        </CCol>
    
    
    
        <Footerlayout></Footerlayout>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,

        };
    },
    created() {
        AOS.init();

    },
    methods: {
        toggle() {
            this.isActive = !this.isActive;
        },
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}

.custom-select {
    display: inline-block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 1.75rem 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    vertical-align: middle;
    border: 1px solid;
    border-radius: 0.25rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: #768192;
    background: #fff url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23636f83' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e) no-repeat right 0.75rem center / 8px 10px;
    border-color: #d8dbe0;
    border: none;
}
</style>